import React from 'react'

const Aumreports = ({ reportData, convertFormet }) => {
    const dpd_reports_TotalCases = reportData?.data?.dpd_reports?.reduce((sum, report) => Number(sum) + Number(report.dpd_count), 0);
    const dpd_reports_TotalLoanAmount = reportData?.data?.dpd_reports?.reduce((sum, report) => Number(sum) + Number(report.loan_amount), 0);
    const casesGrandTotal = Number(reportData.data["running_cases"]["Running Cases"]) + dpd_reports_TotalCases;
    const loadanGrandTotal = convertFormet(Number(reportData.data["running_cases"]["Loan Amount"]) + dpd_reports_TotalLoanAmount);

    return (
        <div className="p-4 md:p-8 overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-[#1D3E50] text-lg font-bold">Report Details</h2>
                <span className="text-sm text-[#1D3E50] font-medium">DATE: {new Date().toLocaleDateString()}</span>
            </div>

            <table className="w-full text-sm border border-gray-300 rounded-md overflow-hidden shadow-sm mb-6">
                <thead style={{ backgroundColor: "#1D3E50" }}>
                    <tr>
                        <th className="p-3 text-left text-white font-semibold whitespace-nowrap">DOMAIN NAME</th>
                        <th className="p-3 text-left text-white font-semibold whitespace-nowrap">AUM</th>
                    </tr>
                </thead>
                <tbody className="text-gray-800">
                    <tr className="border-t border-gray-300 hover:bg-[#EDF3F6]">
                        <td className="p-3 border font-medium text-[#1D3E50] whitespace-nowrap">DPDs</td>
                        <td className="p-3 border whitespace-nowrap">
                            <span className="font-medium text-gray-700">Total Cases: </span>{dpd_reports_TotalCases}<br />
                            <span className="font-medium text-gray-700">Loan Amt: </span>{convertFormet(dpd_reports_TotalLoanAmount)}
                        </td>
                    </tr>

                    {reportData.data.dpd_reports.map((dpd_report, index) => (
                        <tr key={index} className="border-t border-gray-300 hover:bg-[#EDF3F6]">
                            <td className="p-3 border font-medium text-[#1D3E50] whitespace-nowrap">{dpd_report.label}</td>
                            <td className="p-3 border whitespace-nowrap">
                                <span className="font-medium text-gray-700">Total Cases: </span>{dpd_report.dpd_count}<br />
                                <span className="font-medium text-gray-700">Loan Amt: </span>{convertFormet(dpd_report.loan_amount)}
                            </td>
                        </tr>
                    ))}

                    <tr className="border-t border-gray-300 hover:bg-[#EDF3F6]">
                        <td className="p-3 border font-medium text-[#1D3E50] whitespace-nowrap">Running</td>
                        <td className="p-3 border whitespace-nowrap">
                            <span className="font-medium text-gray-700">Total Cases: </span>{reportData.data["running_cases"]["Running Cases"]}<br />
                            <span className="font-medium text-gray-700">Loan Amt: </span>{convertFormet(reportData.data["running_cases"]["Loan Amount"] ?? 0)}
                        </td>
                    </tr>

                    <tr className="bg-[#F5F9FB] font-semibold border-t border-gray-300">
                        <td className="p-3 border text-[#1D3E50] whitespace-nowrap">Grand Total :</td>
                        <td className="p-3 border whitespace-nowrap">
                            <span className="font-medium text-gray-700">Total Cases: </span>{casesGrandTotal}<br />
                            <span className="font-medium text-gray-700">Loan Amt: </span>{loadanGrandTotal}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table className="w-full text-sm border border-gray-300 rounded-md overflow-hidden shadow-sm mb-6">
                <thead style={{ backgroundColor: "#1D3E50" }}>
                    <tr>
                        <th className="p-3 text-white font-semibold whitespace-nowrap">AUM</th>
                        <th className="p-3 text-white font-semibold whitespace-nowrap">BANK BALANCE</th>
                        <th className="p-3 text-white font-semibold whitespace-nowrap">LOAN AMT POS</th>
                        <th className="p-3 text-white font-semibold whitespace-nowrap">REPAYM AMT POS</th>
                    </tr>
                </thead>
                <tbody className="text-center text-gray-800">
                    <tr className="border-t border-gray-300 hover:bg-[#EDF3F6]">
                        <td className="p-3 border
                         border">—</td>
                        <td className="p-3 border
                         border">—</td>
                        <td className="p-3 border
                         border font-semibold text-[#1D3E50]">7,570,700</td>
                        <td className="p-3 border
                         border font-semibold text-[#1D3E50]">9,295,450</td>
                    </tr>
                </tbody>
            </table>

            <table className="w-full text-sm border border-gray-300 rounded-md overflow-hidden shadow-sm">
                <thead style={{ backgroundColor: "#1D3E50" }}>
                    <tr>
                        <th className="p-3 text-white font-semibold text-left whitespace-nowrap">Status</th>
                        <th className="p-3 text-white font-semibold text-center whitespace-nowrap">Cases</th>
                        <th className="p-3 text-white font-semibold text-center whitespace-nowrap">Loan Amount</th>
                        <th className="p-3 text-white font-semibold text-center whitespace-nowrap">Repayment Amount</th>
                    </tr>
                </thead>
                <tbody className="text-gray-800 text-sm">
                    <tr className="border-t border-gray-300 hover:bg-[#EDF3F6]">
                        <td className="p-3 border
                         font-medium text-[#1D3E50] whitespace-nowrap">Closed</td>
                        <td className="p-3 border text-center whitespace-nowrap">{reportData.data['closed_cases']['closed_cases']}</td>
                        <td className="p-3 border text-center whitespace-nowrap">{convertFormet(reportData.data['closed_cases']['loan_amount'])}</td>
                        <td className="p-3 border text-center whitespace-nowrap">{convertFormet(reportData.data['closed_cases']['repayment_amount'])}</td>
                    </tr>
                    <tr className="border-t border-gray-300 hover:bg-[#EDF3F6]">
                        <td className="p-3 border font-medium text-[#1D3E50] whitespace-nowrap">Part-Payment</td>
                        <td className="p-3 border text-center whitespace-nowrap">{reportData.data['part_payment']['cases']}</td>
                        <td className="p-3 border text-center whitespace-nowrap">{convertFormet(reportData.data['part_payment']['loan_amount'])}</td>
                        <td className="p-3 border whitespace-nowrap text-center">{convertFormet(reportData.data['part_payment']['repayment_amount'])}</td>
                    </tr>
                    <tr className="bg-[#F5F9FB] font-semibold border-t border-gray-300">
                        <td className="p-3 border
                         text-[#1D3E50]">Grand-Total</td>
                        <td className="p-3 border
                         text-center">
                            {Number(reportData.data['closed_cases']['closed_cases']) + Number(reportData.data['part_payment']['cases'])}
                        </td>
                        <td className="p-3 border
                         text-center">
                            {convertFormet(
                                Number(reportData.data['closed_cases']['loan_amount']) +
                                Number(reportData.data['part_payment']['loan_amount'])
                            )}
                        </td>
                        <td className="p-3 border
                         text-center">
                            {convertFormet(
                                Number(reportData.data['closed_cases']['repayment_amount']) +
                                Number(reportData.data['part_payment']['repayment_amount'])
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    )
}

export default Aumreports
